import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-acceptableusepolicy',
  templateUrl: './acceptableusepolicy.component.html',
  styleUrls: ['./acceptableusepolicy.component.scss']
})
export class AcceptableUsePolicyComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
